import { ApiResult, CrudService } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ParametroValorEntity } from '@catalogo/models';
import { CONFIGURACAO_API_URL, OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'any' })
export class ParametroValorOperacaoDataService extends CrudService<ParametroValorEntity> {

  protected url: string;

  constructor(
    @Inject(OPERACAO_API_URL) protected urlBase: string,
    @Inject(HttpClient) protected httpClient: HttpClient
  ) {
    super(CONFIGURACAO_API_URL, httpClient);

    this.url = `${this.urlBase}/v1/parametrovalor`;
  }

  public getParametroOperacaoValor = () => this.httpClient.get<ApiResult<ParametroValorEntity[]>>(`${this.url}/globaloperacao`);
  public createOrUpdateOperacao = (record: ParametroValorEntity[]) => this.httpClient.post<ParametroValorEntity>(this.url, record);
  public obterPorCodigo = (codigo: string) =>
    this.httpClient.get<ApiResult<ParametroValorEntity>>(`${this.url}/${codigo}`);
}
